import 'scss/solutions/IoT-developer-platform.scss'
import 'babel-polyfill'
import 'js/libs/common'
import 'js/libs/utils-solutions'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min.js'
$(function () {
  var baseSwiper = new Swiper('.swiper-container-base', {
    width: 1080,
    pagination: '.swiper-pagination-base',
    paginationClickable: true
  })
  $('.base-tabs li').hover(function (e) {
    var $pagination = $('.swiper-pagination-base')
    $('.base-tabs').find('li.solution-item-active').removeClass('solution-item-active')
    $pagination.find('.swiper-pagination-bullet').eq($(this).data('eq')).trigger('click')
  }, function () {
    $(this).addClass('solution-item-active')
  })
  var dataApplySwiper = new Swiper('.swiper-container-apply', {
    width: 1080,
    pagination: '.swiper-pagination-apply',
    paginationClickable: true
  })
  $('.apply-tabs li').hover(function (e) {
    var $pagination = $('.swiper-pagination-apply')
    $('.apply-tabs').find('li.solution-item-active').removeClass('solution-item-active')
    $pagination.find('.swiper-pagination-bullet').eq($(this).data('eq')).trigger('click')
  }, function () {
    $(this).addClass('solution-item-active')
  })
  $('.solutions-navigator-base li').click(function () {
    $('.solutions-navigator-base').find('li.solutions-active').removeClass('solutions-active')
    $(this).addClass('solutions-active')
    $('.solutions-item-ability').find('.solution-item-wrap').removeClass('solution-ability-active')
    $('.solutions-item-ability').find(`.solution-item-wrap.${$(this).data('nav')}`).addClass('solution-ability-active')
  })
  $('.solutions-navigator-plan li').click(function () {
    $('.solutions-navigator-plan').find('li.solutions-active').removeClass('solutions-active')
    $(this).addClass('solutions-active')
    $('.solutions-item-plan').find('.solution-item-wrap').removeClass('solution-plan-active')
    $('.solutions-item-plan').find(`.solution-item-wrap.${$(this).data('nav')}`).addClass('solution-plan-active')
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/IoT-developer-platform.js